import React from "react";

const FormError = (props) => {
  if (!props.error && !props.validationError) return null;
  let errors = [];

  if (props.error) {
    errors.push(props.error);
  }

  if (props.validationError) {
    errors.push(props.validationMsg);
  }

  return (
    <div className="FormError">
      <p>{errors.join(". ")}</p>
    </div>
  )
}

FormError.defaultProps = {
  validationError: false,
  validationMsg: "Contains Invalid values"
}

export default FormError;